<template>
    <div class="cv3-os-card">
        <div class="cv3-os-top">
            <span class="cv3-os-avatar">
                <UserIcon v-if="order.isGuest" :size="16" />
                <template v-else>{{ initials }}</template>
            </span>
            <div class="cv3-os-id">
                <span class="cv3-os-name">{{ order.clientName }}</span>
                <span class="cv3-os-date">{{ order.date }}</span>
            </div>
            <button type="button" class="cv3-os-dismiss" :title="$t('common.hide')" @click="$emit('dismiss')">
                <XIcon :size="16" />
            </button>
        </div>

        <div class="cv3-os-lines">
            <div v-for="(l, i) in order.lines" :key="i" class="cv3-os-line">
                <span class="cv3-os-qty">{{ l.qty }}x</span>
                <span class="cv3-os-lname">{{ l.name }}</span>
                <span class="cv3-os-lprice">{{ formatPrice(l.price) }}€</span>
            </div>
        </div>

        <div class="cv3-os-foot">
            <div class="cv3-os-total">
                <span class="cv3-os-total-label">{{ $t('checkout.v3.total_ttc_short') }}</span>
                <span class="cv3-os-total-val">{{ formatPrice(order.total) }}€</span>
            </div>
            <button type="button" class="cv3-os-open" :disabled="busy" @click="$emit('open')">
                {{ $t('checkout.v3.open_sale_btn') }}
            </button>
        </div>
    </div>
</template>

<script>
import { X as XIcon, User as UserIcon } from 'lucide-vue'

export default {
    name: 'OpenSaleCard',
    components: { XIcon, UserIcon },
    props: {
        order: { type: Object, required: true },
        busy: { type: Boolean, default: false },
    },
    computed: {
        initials() {
            const a = (this.order.firstName || '').trim()
            const b = (this.order.lastName || '').trim()
            const i = (a[0] || '') + (b[0] || '')
            return i.toUpperCase() || (this.order.clientName || '?').slice(0, 2).toUpperCase()
        },
    },
    methods: {
        formatPrice(v) {
            return (Math.round((Number(v) || 0) * 100) / 100).toFixed(2).replace('.', ',')
        },
    },
}
</script>

<style scoped lang="scss">
.cv3-os-card {
    background: var(--cv3-panel);
    border: 1px solid var(--cv3-border);
    border-radius: 14px;
    padding: 14px;
    margin-bottom: 12px;
    box-shadow: var(--cv3-shadow);
}
.cv3-os-top {
    display: flex;
    align-items: center;
    gap: 10px;
}
.cv3-os-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: var(--cv3-icon-tint);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
}
.cv3-os-id {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1 1 auto;
}
.cv3-os-name {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cv3-os-date {
    font-size: 11px;
    color: var(--cv3-muted);
}
.cv3-os-dismiss {
    border: 0;
    background: transparent;
    color: var(--cv3-muted);
    display: inline-flex;
    &:hover {
        color: #ff8787;
    }
}
.cv3-os-lines {
    margin: 12px 0;
    display: flex;
    flex-direction: column;
    gap: 7px;
}
.cv3-os-line {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 13px;
}
.cv3-os-qty {
    color: var(--cv3-accent-2);
    font-weight: 700;
    flex-shrink: 0;
}
.cv3-os-lname {
    flex: 1 1 auto;
    color: var(--cv3-text-2);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cv3-os-lprice {
    color: var(--cv3-text);
    font-weight: 600;
    flex-shrink: 0;
}
.cv3-os-foot {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    padding-top: 12px;
    border-top: 1px solid var(--cv3-border);
}
.cv3-os-total {
    display: flex;
    flex-direction: column;
}
.cv3-os-total-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: var(--cv3-muted);
}
.cv3-os-total-val {
    font-size: 18px;
    font-weight: 800;
}
.cv3-os-open {
    border: 0;
    border-radius: 11px;
    background: var(--cv3-accent);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 16px;
    box-shadow: 0 8px 20px -8px rgba(125, 45, 189, 0.7);
}
</style>
